import { render, staticRenderFns } from "./celleKaifaInfo.vue?vue&type=template&id=21f3c4f9&scoped=true"
import script from "./celleKaifaInfo.vue?vue&type=script&lang=js"
export * from "./celleKaifaInfo.vue?vue&type=script&lang=js"
import style0 from "./celleKaifaInfo.vue?vue&type=style&index=0&id=21f3c4f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f3c4f9",
  null
  
)

export default component.exports